import React from 'react'
import LoginRegisterLogo from '../components/LogoLoginRegister'
import SalesAuthTokenComponent from '../components/SalesAuthTokenComponent'
// import "../styles/legacy/style.scss";
import { useTranslation } from 'react-i18next'

const SalesAuthTokenLogin = () => {
  const { t } = useTranslation();

  return (
    <>
      <div className="entry entry_loginregister">
        <div className="entry__wrapper entry__wrapper-kyc">
          <LoginRegisterLogo />

          <div className="h2 entry__title">
            {t('Sign In')}
          </div>

          <div className="entry__text">
            {t('Sign in with email address')}
          </div>

          <SalesAuthTokenComponent />
        </div>
      </div>
    </>
  );
};

export default SalesAuthTokenLogin;
